import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import * as RouterPath from '@/classification/RouterPath';
import * as JwtUtil from '../common/JwtUtil';
import store from '../store';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: RouterPath.TOP,
    name: '検定トップ',
    meta: {
      isPublic: true,
      title: 'あの花検定',
    },
    component: () => import(/* webpackChunkName: "main" */ '@/views/Top.vue'),
  },
  {
    path: RouterPath.FAQ,
    name: 'よくあるご質問',
    meta: {
      isPublic: true,
      title: 'よくある質問 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "main" */ '@/views/Faq.vue'),
  },
  {
    path: RouterPath.TOKUSHOHO,
    name: '特定商取引法に基づく表記',
    meta: {
      isPublic: true,
      title: '特定商取引法に基づく表記 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "main" */ '@/views/Tokushoho.vue'),
  },
  {
    path: RouterPath.PRIVACY,
    name: 'プライバシーポリシー',
    meta: {
      isPublic: true,
      title: 'プライバシーポリシー | あの花検定',
    },
    component: () => import(/* webpackChunkName: "main" */ '@/views/Privacy.vue'),
  },
  {
    path: RouterPath.LOGIN,
    name: 'ログイン',
    meta: {
      isPublic: true,
      title: 'ログイン・会員登録 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/Login.vue'),
  },
  {
    path: RouterPath.PRE_REGIST,
    name: '仮申し込み完了',
    meta: {
      isPublic: true,
      title: '仮申込完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/PreRegist.vue'),
  },
  {
    path: RouterPath.MY_PAGE,
    name: 'マイページ',
    meta: {
      title: 'マイページ',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/MyPage.vue'),
  },
  {
    path: RouterPath.ENTRY,
    name: '会員情報登録',
    meta: {
      isPublic: true,
      title: '会員情報登録',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/Entry.vue'),
  },
  {
    path: RouterPath.ACCOUNT_CONFIRM,
    name: '登録内容確認',
    meta: {
      isPublic: true,
      title: '内容確認',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/RegistConfirm.vue'),
  },
  {
    path: RouterPath.ACCOUNT_COMPLETE,
    name: '会員登録完了',
    meta: {
      isPublic: true,
      title: '登録完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/RegistComplete.vue'),
  },
  {
    path: RouterPath.UPDATE_INFO,
    name: '会員情報変更',
    meta: {
      title: '会員情報変更',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_info/UpdateInfo.vue'),
  },
  {
    path: RouterPath.UPDATE_INFO_COMPLETE,
    name: '会員情報変更完了',
    meta: {
      title: '会員情報変更完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_info/UpdateInfoComplete.vue'),
  },
  {
    path: RouterPath.ID_FORGET,
    name: 'IDをお忘れの方',
    meta: {
      isPublic: true,
      title: 'IDをお忘れの方 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/id_forget/IdForget.vue'),
  },
  {
    path: RouterPath.ID_FORGET_COMPLETE,
    name: 'IDをお忘れの方（メール送信完了）',
    meta: {
      isPublic: true,
      title: 'IDをお忘れの方',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/id_forget/IdForgetComplete.vue'),
  },
  {
    path: RouterPath.PASS_FORGET,
    name: 'パスワードをお忘れの方',
    meta: {
      isPublic: true,
      title: 'パスワードをお忘れの方 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/pass_forget/PassForget.vue'),
  },
  {
    path: RouterPath.PASS_FORGET_SEND,
    name: 'パスワード再設定メール送信完了',
    meta: {
      isPublic: true,
      title: 'パスワードをお忘れの方',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/pass_forget/PassForgetSend.vue'),
  },
  {
    path: RouterPath.PASS_FORGET_SETTING,
    name: 'パスワード再設定',
    meta: {
      isPublic: true,
      title: 'パスワード再設定',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/pass_forget/PassForgetSetting.vue'),
  },
  {
    path: RouterPath.PASS_FORGET_COMPLETE,
    name: 'パスワード再設定完了',
    meta: {
      isPublic: true,
      title: 'パスワード再設定',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/pass_forget/PassForgetComplete.vue'),
  },
  {
    path: RouterPath.UPDATE_MAIL,
    name: 'メールアドレス変更',
    meta: {
      title: 'メールアドレス変更',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_mail/UpdateMail.vue'),
  },
  {
    path: RouterPath.UPDATE_MAIL_SEND,
    name: '変更メール送信完了',
    meta: {
      title: '変更メール送信完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_mail/UpdateMailSend.vue'),
  },
  {
    path: RouterPath.UPDATE_MAIL_CONFIRM,
    name: 'メールアドレス変更の認証',
    meta: {
      isPublic: true,
      title: 'メールアドレス変更',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_mail/UpdateMailConfirm.vue'),
  },
  {
    path: RouterPath.UPDATE_MAIL_COMPLETE,
    name: 'メールアドレス変更完了',
    meta: {
      title: 'メールアドレス変更完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_mail/UpdateMailComplete.vue'),
  },
  {
    path: RouterPath.UPDATE_PASS,
    name: 'パスワード変更',
    meta: {
      title: 'パスワード変更',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_pass/UpdatePass.vue'),
  },
  {
    path: RouterPath.UPDATE_PASS_COMPLETE,
    name: 'パスワード変更完了',
    meta: {
      title: 'パスワード変更完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/update_pass/UpdatePassComplete.vue'),
  },
  {
    path: RouterPath.DELETE,
    name: 'アカウント削除',
    meta: {
      title: 'アカウント削除',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/delete/Delete.vue'),
  },
  {
    path: RouterPath.DELETE_CONFIRM,
    name: 'アカウント削除の認証',
    meta: {
      title: 'アカウント削除',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/delete/DeleteConfirm.vue'),
  },
  {
    path: RouterPath.DELETE_COMPLETE,
    name: 'アカウント削除の完了',
    meta: {
      isPublic: true,
      title: 'アカウント削除完了',
    },
    component: () => import(/* webpackChunkName: "account" */ '@/views/account/delete/DeleteComplete.vue'),
  },
  {
    path: RouterPath.KENTEI_DETAIL,
    name: '検定詳細',
    meta: {
      isPublic: true,
      title: '検定詳細 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "exam" */ '@/views/kentei/ExamDetail.vue'),
  },
  {
    path: RouterPath.EXAM_READY,
    name: '受験内容確認',
    meta: {
      isPublic: true,
      title: '受験内容確認',
    },
    component: () => import(/* webpackChunkName: "exam" */ '@/views/exam/ready/ExamReady.vue'),
  },
  {
    path: RouterPath.EXAM_FINISH,
    name: '試験終了',
    meta: {
      title: '試験終了',
    },
    component: () => import(/* webpackChunkName: "exam" */ '@/views/exam/finish/ExamFinish.vue'),
  },
  {
    path: RouterPath.EXAM,
    name: '試験',
    meta: {
      title: '試験',
    },
    component: () => import(/* webpackChunkName: "exam_main" */ '@/views/exam/Exam.vue'),
  },
  {
    path: RouterPath.EXAM_RESULT,
    name: '試験結果',
    meta: {
      title: '試験結果',
    },
    component: () => import(/* webpackChunkName: "exam" */ '@/views/exam/result/ExamResult.vue'),
  },
  {
    path: RouterPath.GUEST_EXAM_FINISH,
    name: '試験終了(アカウント登録不要)',
    meta: {
      isPublic: true,
      title: '試験終了',
    },
    component: () => import(/* webpackChunkName: "guest_exam" */ '@/views/guest_exam/guest_finish/GuestExamFinish.vue'),
  },
  {
    path: RouterPath.GUEST_EXAM,
    name: '試験(アカウント登録不要)',
    meta: {
      isPublic: true,
      title: '試験',
    },
    component: () => import(/* webpackChunkName: "guest_exam_main" */ '@/views/guest_exam/GuestExam.vue'),
  },
  {
    path: RouterPath.GUEST_EXAM_RESULT,
    name: '試験結果(アカウント登録不要)',
    meta: {
      isPublic: true,
      title: '試験結果',
    },
    component: () => import(/* webpackChunkName: "guest_exam" */ '@/views/guest_exam/guest_result/GuestExamResult.vue'),
  },
  {
    path: RouterPath.TEST_EXAM_READY,
    name: '体験版',
    meta: {
      isPublic: true,
      title: '体験版 | あの花検定',
    },
    component: () => import(/* webpackChunkName: "test_exam" */ '@/views/test_exam/ready/TestExamReady.vue'),
  },
  {
    path: RouterPath.TEST_EXAM,
    name: 'テスト試験',
    meta: {
      isPublic: true,
      title: '体験版',
    },
    component: () => import(/* webpackChunkName: "test_exam_main" */ '@/views/test_exam/TestExam.vue'),
  },
  {
    path: RouterPath.TEST_EXAM_FINISH,
    name: 'テスト試験終了',
    meta: {
      isPublic: true,
      title: '体験版',
    },
    component: () => import(/* webpackChunkName: "test_exam" */ '@/views/test_exam/finish/TestExamFinish.vue'),
  },
  {
    path: RouterPath.GOODS_LIST,
    name: 'グッズ一覧',
    meta: {
      isPublic: true,
      title: 'グッズ一覧',
    },
    component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/list/GoodsList.vue'),
  },
  {
    path: RouterPath.GOODS_DETAIL,
    name: 'グッズ詳細',
    meta: {
      isPublic: true,
      title: 'グッズ詳細',
    },
    component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/detail/GoodsDetail.vue'),
  },
  {
    path: RouterPath.GOODS_RESULT,
    name: 'グッズ購入完了',
    meta: {
      isPublic: true,
      title: 'グッズ購入完了',
    },
    component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/result/GoodsResult.vue'),
  },
  {
    path: `${RouterPath.CONTENTS}/:templateCode`,
    name: '',
    meta: {
      isPublic: true,
    },
    component: () => import(/* webpackChunkName: "main" */ '@/views/ContentsTemplate.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

/**
 * 遷移処理
 * @param to 遷移先ルートオブジェクト
 * @param from 遷移元ルートオブジェクト
 * @param next 遷移用関数
 */
const transitionToNext = (to: any, from: any, next: any) => {
  // isPublic でない場合(=認証が必要な場合)、かつ、ログインしていない場合
  if (to.matched.some((record: any) => !record.meta.isPublic) && JwtUtil.getJwtInfo() === null) {
    // ログイン画面へ強制遷移
    next({ path: RouterPath.LOGIN });
  } else if ((to.path === RouterPath.EXAM || to.path === RouterPath.GUEST_EXAM || to.path === RouterPath.TEST_EXAM) && from.path !== '/') {
    // 遷移先が試験系ページ、かつ別タブでの直表示以外（fromのパスがルート）の場合遷移させない
    next({ path: from.path, query: from.query });
  } else {
    next();
  }
};

/**
 * 検定情報が保存されるのを待機してから遷移する
 * @param to 遷移先ルートオブジェクト
 * @param from 遷移元ルートオブジェクト
 * @param next 遷移用関数
 */
const waitExamStored = (to: any, from: any, next: any) => {
  if (store.state.exam === null) {
    // storeに検定情報がセットされるのをwatchし、値が入れば遷移
    store.watch(
      (state) => state.exam,
      (value) => {
        if (value !== null) {
          transitionToNext(to, from, next);
        }
      },
    );
  } else {
    transitionToNext(to, from, next);
  }
};

router.beforeEach((to, from, next) => {
  waitExamStored(to, from, next);
});

export default router;
